export default __webpack_public_path__ + "static/media/leslie_app.0554fa96.png";